import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import LinearProgress from 'Components/UI/LinearProgress';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getBorderRadius } from 'Components/utils';
import { currency } from 'Helpers/Formats';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(2),
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(1),
  },
  textSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  progressBar: {
    height: theme.spacing(1.5),
  },
  monthlyExpenses: {
    marginBottom: theme.spacing(2),
  },
});

const ProgressCard = ({
  className,
  classes,
  stepResource,
}) => {
  // Calculate percent funded
  let amountFunded = 0;
  const virtualAccountSetupsList = stepResource.attr('facetPlanVirtualAccountSetups').resources().list();
  for (const account of virtualAccountSetupsList) {
    const balance = account.attr('balanceForThisOutcome');
    if (balance) {
      amountFunded += parseInt(balance, 10);
    }
  }
  const outcomeGoalAmount = parseInt(stepResource.attr('outcomeGoalAmount'), 10);

  if (!outcomeGoalAmount) {
    return null;
  }

  const amountFundedPercent = ((amountFunded / outcomeGoalAmount) * 100).toFixed(2);
  // The progress bar should not attempt to display a value over 100% or else it looks messed up
  const amountFundedPercentForProgressBar = amountFundedPercent > 100 ? 100 : amountFundedPercent;

  // Calculate amount needed
  const amountNeeded = outcomeGoalAmount - amountFunded;
  return (
    <Paper
      className={classNames(classes.root, className)}
      variant={'outlined'}
    >
      <div className={classes.textSection}>
        <div className={classes.row}>
          <Typography
            color={'primaryGray'}
            variant={'h5'}
            weight={'medium'}
          >
            Amount Needed: {currency(amountNeeded, true)}
          </Typography>
          <Typography
            color={'primary'}
            variant={'h5'}
            weight={'medium'}
          >
            {amountFundedPercent}%
          </Typography>
        </div>
      </div>
      <LinearProgress
        color="primaryToAccentBlue"
        className={classes.progressBar}
        visible
        ProgressProps={{
          variant: 'determinate',
          value: amountFundedPercentForProgressBar,
          className: classes.progressBar,
        }}
      />
    </Paper>
  );
};

ProgressCard.defaultProps = {
  className: '',
};

ProgressCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  stepResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProgressCard);
